import { combineReducers } from "redux";
import userReducer from "./userReducer";

const rootReducer = combineReducers({ userAuthInfoState: userReducer });

export default rootReducer